import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Section, Text } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import SingleChoice from 'modules/core/components/Filter/filters/SingleChoice'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import { companyLegalEntities } from 'modules/core/store/collections/legalEntities'

import {
  ContractTaxonomy,
  useFetchContractsTaxonomies,
} from 'modules/contracts/hooks/useFetchContractsTaxonomies'
import Item from 'modules/payroll_bundle/pages/settings/Content/TypesOfCompensation/Item'

const Content = () => {
  const legalEntities = companyLegalEntities(companies.current)
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const legalEntitiesOptions = useUnsafeMemo(
    () =>
      legalEntities.map((legalEntity) => ({
        value: legalEntity.id,
        label: legalEntity.name || '',
      })),
    [legalEntities]
  )
  const legalEntityIds = legalEntities.map((l) => l.id)
  const { taxonomies: taxonomies } = useFetchContractsTaxonomies(legalEntityIds)
  const [selectedLegalEntity, setSelectedLegalEntity] = React.useState('')
  const taxonomiesByLegalEntity = groupBy(
    taxonomies.activeTaxonomies(),
    (taxonomy) => taxonomy.legalEntityId
  )

  const taxonomiesByLegalEntityPredefinedCount = taxonomiesByLegalEntity[
    selectedLegalEntity
  ]?.filter((contractTaxonomy: ContractTaxonomy) => contractTaxonomy.default === true).length
  const taxonomiesByLegalEntityCustomCount = taxonomiesByLegalEntity[selectedLegalEntity]?.filter(
    (contractTaxonomy: ContractTaxonomy) => contractTaxonomy.default === false
  ).length

  const navigateToSettingsLegalEntityContracts = () => {
    navigate(
      navigation.settings.legalEntitiesId.contracts.fullPath({
        id: selectedLegalEntity,
      })
    )
  }

  return (
    <Box gap="s12">
      <Box width="fit-content">
        <SingleChoice
          noFooter
          label={i18n.t(
            'app_store_v2.apps.payroll_bundle.settings.compensation_types.selector_label'
          )}
          value={selectedLegalEntity}
          options={legalEntitiesOptions}
          onValueChange={setSelectedLegalEntity}
        />
      </Box>
      <Box
        component="ul"
        borderRadius={{ all: 'abs016' }}
        background="grey000White"
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
      >
        {selectedLegalEntity ? (
          <>
            <Item
              title={i18n.t(
                'app_store_v2.apps.payroll_bundle.settings.compensation_types.title_predefined',
                {
                  count: taxonomiesByLegalEntityPredefinedCount || 0,
                }
              )}
              onClick={navigateToSettingsLegalEntityContracts}
            />
            <Item
              title={i18n.t(
                'app_store_v2.apps.payroll_bundle.settings.compensation_types.title_custom',
                {
                  count: taxonomiesByLegalEntityCustomCount || 0,
                }
              )}
              onClick={navigateToSettingsLegalEntityContracts}
            />
          </>
        ) : (
          <Box padding="s24">
            <Text.Normal color="grey1000" weight="medium">
              {i18n.t(
                'app_store_v2.apps.payroll_bundle.settings.compensation_types.empty_description'
              )}
            </Text.Normal>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const TypesOfCompensation = () => {
  return (
    <Section
      title={i18n.t('app_store_v2.apps.payroll_bundle.settings.compensation_types.section_title')}
      illustration={'money-bag'}
      description={i18n.t(
        'app_store_v2.apps.payroll_bundle.settings.compensation_types.section_description'
      )}
    >
      <Content />
    </Section>
  )
}

export default TypesOfCompensation
